import { ReactNode } from "react";

interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}

const FadeIn = ({ children, className = "" }: FadeInProps) => (
  <div className={className}>{children}</div>
);

export default FadeIn;
